import { useForm, UseFormReturn } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

/**
 * Options for the useBefehlForm hook
 */
export interface UseBefehlFormOptions<T = unknown> {
  readOnly?: boolean
  activateEmptyFieldWarnings?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: z.ZodType<any, any, any>
  initialData?: T
}

/**
 * A hook for Befehl form state and validation that supports empty warning state for readonly fields
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useBefehlForm<TSchema extends z.ZodType<any, any, any>>(
  options: UseBefehlFormOptions<z.infer<TSchema>>
): UseFormReturn<z.infer<TSchema>> {
  const defaultValues = options.initialData ?? options.schema.parse({})

  return useForm<z.infer<TSchema>>({
    defaultValues,
    criteriaMode: 'all',
    resolver: zodResolver(options.schema)
  })
}
